module.exports = __webpack_public_path__ + "assets/img/b1eadb48cef8cc50118f4f78517a53cf.png";